/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { CSSProperties, FC, useRef, useState } from 'react';
import { classNames } from '../../../utils';
import { useNavigate, useMatch } from 'react-router-dom';
import { Transition } from 'react-transition-group';

interface NavigationItemProps {
  label: string;
  dest: string;
  icon: React.ReactNode;
}

const NavigationItem: FC<NavigationItemProps> = ({ label, dest, icon }) => {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const defaultStyle: CSSProperties = {
    transition: `all 200ms ease-in-out`,
    opacity: 0,
    left: '100%',
    visibility: 'hidden',
  };

  const transitionStyles: Record<string, CSSProperties> = {
    entering: { opacity: 1, left: '100%', visibility: 'visible' },
    entered: { opacity: 1, left: '100%', visibility: 'visible' },
    exiting: { opacity: 0, left: '66.666666%', visibility: 'visible' },
    exited: { opacity: 0, left: '66.666666%', visibility: 'hidden' },
  };

  const match = useMatch({
    path: dest,
    end: false,
  });
  const navigate = useNavigate();

  const handleOnSelected = () => {
    navigate(dest);
  };

  return (
    <li className='relative'>
      <button
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
        className={classNames(
          'group z-20 flex h-12 w-full cursor-pointer flex-col items-center justify-center font-medium hover:text-white',
          match
            ? 'bg-black bg-opacity-50 text-green hover:text-white'
            : 'text-gray-dark hover:bg-black hover:bg-opacity-20',
        )}
        onClick={handleOnSelected}
      >
        <div className='mb-1 flex-shrink-0 group-hover:text-white'>{icon}</div>

        <div
          className={classNames(
            'absolute top-0 left-0 right-0 bottom-0 z-30',
            match ? 'border-r-5 border-r-green' : '',
          )}
        />
      </button>
      <Transition unmountOnExit={true} in={isOpen} timeout={200} nodeRef={ref}>
        {(state) => (
          <span
            style={{ ...defaultStyle, ...transitionStyles[state] }}
            className={classNames(
              'absolute top-1/2 z-50 ml-3 -translate-y-1/2 transform rounded bg-gray-darkest px-6 py-2 text-xxs font-semibold tracking-tight text-white after:absolute after:right-full after:top-1/2 after:-translate-y-1/2 after:border-[5px] after:border-l-transparent after:border-r-gray-darkest after:border-b-transparent after:border-t-transparent',
            )}
          >
            {label}
          </span>
        )}
      </Transition>
    </li>
  );
};

export default NavigationItem;
